import { render } from "./DynvibeWordCloud.vue?vue&type=template&id=18b88e1c&scoped=true"
import script from "./DynvibeWordCloud.vue?vue&type=script&lang=js"
export * from "./DynvibeWordCloud.vue?vue&type=script&lang=js"

import "./DynvibeWordCloud.vue?vue&type=style&index=0&id=18b88e1c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b88e1c"]])

export default __exports__